module.exports = __webpack_public_path__ + "img/yes.6e08f7a2.svg";